(function () {
  'use strict';

  window.__typesenseActive = true;

  var configEl = document.getElementById('ts-config');
  if (!configEl) return;
  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
  if (!config || !config.apiUrl) return;

  var apiUrl           = config.apiUrl;
  var collectionHandle = config.collectionHandle;
  var sectionId        = config.sectionId || 'main';
  var PER_PAGE         = 40;

  var currentPage = 0;
  var totalFound  = 0;
  var loading     = false;
  var fetchGen    = 0;

  var gridEl = document.querySelector('ul.product-grid');
  if (!gridEl) return;

  var SORT_MAP = {
    'manual':             'catalogue_rank:asc',
    'price-ascending':    'price:asc',
    'price-asc':          'price:asc',
    'price-descending':   'price:desc',
    'price-desc':         'price:desc',
    'created-descending': 'created_at:desc',
    'created-desc':       'created_at:desc',
    'created-ascending':  'created_at:asc',
    'created-asc':        'created_at:asc',
  };

  function getTsSort() {
    var params = new URLSearchParams(window.location.search);
    var customSort = params.get('custom_sort') || '';
    if (customSort === 'discount-desc') return 'discount_bps:desc';
    if (customSort === 'discount-asc')  return 'discount_bps:asc';
    var shopifySort = params.get('sort_by') || '';
    return SORT_MAP[shopifySort] || 'catalogue_rank:asc';
  }

  var SVG_ARROW = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">'
    + '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"'
    + ' stroke-width="var(--icon-stroke-width)" vector-effect="non-scaling-stroke"'
    + ' d="M4.25 10h11.5m0 0-4-4m4 4-4 4"/></svg>';

  var SVG_CARET = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"'
    + ' xmlns="http://www.w3.org/2000/svg">'
    + '<path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor"'
    + ' stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var SVG_CHECKMARK = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"'
    + ' xmlns="http://www.w3.org/2000/svg" class="icon-checkmark">'
    + '<path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988'
    + ' 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007'
    + ' 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658"'
    + ' stroke="currentColor" stroke-width="var(--icon-stroke-width)"'
    + ' stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var SVG_HEART_EMPTY = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">'
    + '<path d="M16.706 3a5.05 5.05 0 012.028.407 5.24 5.24 0 011.724 1.195 5.513 5.513 0 011.15 1.803'
    + ' 5.706 5.706 0 01-.036 4.253 5.503 5.503 0 01-1.179 1.782v-.001l-8.055 8.401a.502.502 0 01-.735 0'
    + 'l-8.061-8.408H3.54A5.616 5.616 0 012 8.548c0-1.46.556-2.857 1.54-3.884l.369.403-.367-.403'
    + 'a5.135 5.135 0 013.706-1.602c1.387 0 2.721.574 3.706 1.602l1.016 1.058 1.01-1.052'
    + 'a5.251 5.251 0 011.704-1.226A5.056 5.056 0 0116.706 3zM3.053 8.548c0 1.152.439 2.26 1.224 3.08'
    + 'l7.693 8.024 7.694-8.024.006-.008c.4-.403.72-.884.938-1.415a4.513 4.513 0 00.029-3.365'
    + ' 4.38 4.38 0 00-.914-1.433 4.19 4.19 0 00-1.379-.955 4.06 4.06 0 00-3.253.03'
    + 'c-.513.229-.977.563-1.363.98l-.006.007-1.384 1.441a.503.503 0 01-.735 0L10.22 5.47'
    + 'a4.118 4.118 0 00-2.972-1.282 4.108 4.108 0 00-2.821 1.132l-.15.15a4.453 4.453 0 00-1.224 3.08z"/>'
    + '</svg>';

  var SVG_HEART_FILLED = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">'
    + '<path d="M16.706 3a5.05 5.05 0 012.028.407c.644.274 1.23.68 1.724 1.195'
    + 'a5.513 5.513 0 011.15 1.803 5.708 5.708 0 01-.036 4.253 5.505 5.505 0 01-1.179 1.782v-.001'
    + 'l-8.055 8.401a.502.502 0 01-.735 0l-8.061-8.408A5.617 5.617 0 012 8.548'
    + 'c0-1.46.556-2.857 1.54-3.884a5.138 5.138 0 013.708-1.602c1.387 0 2.721.574 3.706 1.602'
    + 'l1.016 1.058 1.01-1.052a5.25 5.25 0 011.704-1.226A5.057 5.057 0 0116.706 3z"/>'
    + '</svg>';

  var SVG_PILL_CLOSE = '<svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<g opacity="var(--close-icon-opacity)">'
    + '<path d="M6 1.5L1 6.5" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>'
    + '<path d="M1 1.5L6 6.5" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>'
    + '</g></svg>';

  // ── helpers ──────────────────────────────────────────────────────────────

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(amount) {
    var n = Number(amount) || 0;
    var s = n.toFixed(2);
    return '£' + (s.slice(-3) === '.00' ? s.slice(0, -3) : s);
  }

  function buildSrcset(url) {
    if (!url) return '';
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return [165, 360, 533, 720, 940, 1200].map(function (w) {
      return esc(url) + sep + 'width=' + w + ' ' + w + 'w';
    }).join(', ');
  }

  function buildArrow(action) {
    var isPrev = action === 'previous';
    return '<button'
      + ' class="slideshow-control slideshow-control--' + action
      + ' button button-unstyled button-unstyled--transparent' + (isPrev ? ' flip-x' : '') + '"'
      + ' on:click="/' + action + '"'
      + ' ref="' + action + '"'
      + ' aria-label="' + (isPrev ? 'Previous image' : 'Next image') + '">'
      + '<span class="svg-wrapper icon-arrow product-card__arrows--hidden">' + SVG_ARROW + '</span>'
      + '<span class="svg-wrapper product-card__arrows">' + SVG_CARET + '</span>'
      + '</button>';
  }

  function buildGallery(images, url, title, productId, isPriorityProduct) {
    var imgs = images.slice(0, 5);
    var n    = imgs.length;

    if (n === 0) {
      return '<div ref="cardGallery" class="card-gallery spacing-style border-style"'
        + ' style="--gallery-aspect-ratio: 4 / 5;"'
        + ' data-product-id="' + productId + '" data-image-ratio="portrait">'
        + '<a class="contents" ref="cardGalleryLink" href="' + esc(url) + '" aria-label="' + title + '"></a>'
        + '</div>';
    }

    var timelineScope = Array.from({ length: n }, function (_, i) {
      return '--slide-' + (i + 1);
    }).join(',');

    var slidesHtml = imgs.map(function (imgUrl, i) {
      var isPriorityImage = isPriorityProduct && i === 0;

      return '<slideshow-slide'
        + ' ref="slides[]"'
        + ' aria-hidden="' + (i === 0 ? 'false' : 'true') + '"'
        + ' class="image__' + String(i === 0)
        + ' product-media-container media-fit product-media-container--image"'
        + ' style="--slideshow-timeline: --slide-' + i + '; --product-media-fit: cover;'
        + ' --grid-template-rows: 50dvh 1fr; --grid-template-rows-desktop: 70dvh 1fr;"'
        + ' slide-id="ts-' + productId + '-' + i + '">'
          + '<div class="product-media" style="--ratio: 0.8"'
          + ' data-media-id="ts-' + productId + '-' + i + '">'
            + '<img class="product-media__image"'
            + ' src="' + esc(imgUrl) + '"'
            + ' srcset="' + buildSrcset(imgUrl) + '"'
            + ' sizes="auto, (min-width:750px) 33vw, 50vw"'
            + ' alt="' + title + '"'
            + ' loading="' + (isPriorityImage ? 'eager' : 'lazy') + '"'
            + ' fetchpriority="' + (isPriorityImage ? 'high' : 'low') + '"'
            + ' decoding="async"'
            + ' width="533" height="666">'
          + '</div>'
        + '</slideshow-slide>';
    }).join('');

    var arrowsHtml = n > 1
      ? '<slideshow-arrows position="center">'
        + buildArrow('previous') + buildArrow('next')
        + '</slideshow-arrows>'
      : '';

    return '<div ref="cardGallery" class="card-gallery spacing-style border-style"'
      + ' style="--gallery-aspect-ratio: 4 / 5;"'
      + ' data-product-id="' + productId + '" data-image-ratio="portrait">'
      + '<a class="contents" ref="cardGalleryLink" href="' + esc(url) + '" aria-label="' + title + '">'
        + '<slideshow-component ref="slideshow"'
          + ' style="--slideshow-timeline:' + timelineScope
          + '; --slideshow-align-items: flex-start;'
          + ' --slide-min-height: auto; --slide-min-height-desktop: auto;"'
          + ' initial-slide="0"'
          + ' data-generic-media-size="' + n + '">'
          + '<slideshow-container ref="slideshowContainer" scrollbar-drag>'
            + arrowsHtml
            + '<slideshow-slides ref="scroller" tabindex="-1">'
              + slidesHtml
            + '</slideshow-slides>'
            + '<div class="slideshow-scrollbar" ref="scrollbar" aria-hidden="true">'
              + '<div class="slideshow-scrollbar__thumb" ref="scrollbarThumb"></div>'
            + '</div>'
          + '</slideshow-container>'
        + '</slideshow-component>'
      + '</a>'
    + '</div>';
  }

  function buildPrice(price, compareAt) {
    var hasDiscount = compareAt > price && compareAt > 0;
    var discountBps = hasDiscount ? Math.round((compareAt - price) / compareAt * 10000) : 0;
    var pct         = hasDiscount ? Math.round((compareAt - price) / compareAt * 100)  : 0;

    var html;
    if (hasDiscount) {
      html = '<span role="group">'
          + '<span class="visually-hidden">Regular price </span>'
          + '<span class="compare-at-price">' + formatMoney(compareAt) + '</span>'
        + '</span> '
        + '<span role="group">'
          + '<span class="visually-hidden">Sale price </span>'
          + '<span class="price">' + formatMoney(price) + '</span>'
        + '</span> '
        + '<span class="price__percentage-off">(-' + pct + '%)</span>';
    } else {
      html = '<span class="price">' + formatMoney(price) + '</span>';
    }
    return { html: html, discountBps: discountBps };
  }

  function buildCard(hit, index) {
    var id        = String(hit.id || '');
    var url       = hit.url || '/products/' + id;
    var title     = esc(hit.title || '');
    var vendor    = esc(hit.vendor || '');
    var badge     = esc(hit.product_badge || '');
    var images    = Array.isArray(hit.images) && hit.images.length
                  ? hit.images : (hit.image ? [hit.image] : []);
    var price     = Number(hit.price) || 0;
    var compareAt = Number(hit.compare_at_price) || 0;
    var priceData = buildPrice(price, compareAt);

    return '<li'
      + ' id="' + sectionId + '-' + id + '"'
      + ' class="product-grid__item product-grid__item--' + index + '"'
      + ' data-page="1"'
      + ' data-product-id="' + id + '"'
      + ' data-discount-bps="' + priceData.discountBps + '"'
      + ' ref="cards[]">'

      + '<product-card class="product-card" data-product-id="' + id + '">'

        + '<a href="' + esc(url) + '" class="product-card__link" ref="productCardLink">'
          + '<span class="visually-hidden">' + title + '</span>'
        + '</a>'

        + '<div class="product-card__content layout-panel-flex layout-panel-flex--column'
          + ' product-grid__card spacing-style border-style gap-style"'
          + ' style="padding-bottom:50px;--product-card-gap:4px;'
          +        '--quick-add-display:none;--quick-add-mobile-display:none;--quick-add-mobile-opacity:0;">'

          + buildWishlistButton(hit)

          + buildGallery(images, url, title, id, index === 0)

          + '<div class="d-product-badges">' + badge + '</div>'

          + '<div class="product-card__vendor-box">'
            + '<p class="product-card__vendor custom custom-typography">' + vendor + '</p>'
          + '</div>'

          + '<a class="contents user-select-text" ref="productTitleLink" href="' + esc(url) + '">'
            + '<p class="product-card-title">' + title + '</p>'
          + '</a>'

          + '<product-price class="text-block paragraph custom custom-typography spacing-style"'
            + ' style="padding-top:12px;--width:100%;font-size:0.875rem;">'
            + '<div ref="priceContainer">' + priceData.html + '</div>'
          + '</product-price>'

        + '</div>'
      + '</product-card>'
    + '</li>';
  }

  function buildWishlistButton(hit) {
    var id          = String(hit.id || '');
    var price       = Number(hit.price) || 0;
    var compareAt   = Number(hit.compare_at_price) || 0;
    var imgUrl      = hit.image ? hit.image + (hit.image.indexOf('?') >= 0 ? '&' : '?') + 'width=480' : '';
    var priceStr    = formatMoney(price);
    var priceRaw    = price.toFixed(2);
    var compareAttr = '';
    if (compareAt > price && compareAt > 0) {
      compareAttr = ' data-product-compare="' + esc(formatMoney(compareAt)) + '"'
        + ' data-product-compare-raw="' + esc(compareAt.toFixed(2)) + '"';
    }
    return '<div class="product-card__wishlist">'
      + '<button type="button" class="wishlist-button wishlist-button--card"'
      + ' data-wishlist-toggle'
      + ' data-product-id="' + esc(id) + '"'
      + ' data-product-handle="' + esc(hit.handle || '') + '"'
      + ' data-product-title="' + esc(hit.title || '') + '"'
      + ' data-product-vendor="' + esc(hit.vendor || '') + '"'
      + ' data-product-url="' + esc(hit.url || '/products/' + id) + '"'
      + ' data-product-image="' + esc(imgUrl) + '"'
      + ' data-product-badge="' + esc(hit.product_badge || '') + '"'
      + ' data-product-price="' + esc(priceStr) + '"'
      + ' data-product-price-raw="' + esc(priceRaw) + '"'
      + ' data-product-available="' + (hit.available ? 'true' : 'false') + '"'
      + compareAttr
      + ' aria-pressed="false" aria-label="Add to wishlist">'
      + '<span class="wishlist-button__icon" aria-hidden="true">'
      + '<span class="wishlist-button__icon-img wishlist-button__icon-img--default">' + SVG_HEART_EMPTY + '</span>'
      + '<span class="wishlist-button__icon-img wishlist-button__icon-img--active">'  + SVG_HEART_FILLED + '</span>'
      + '</span>'
      + '<span class="wishlist-button__label">Wishlist</span>'
      + '</button>'
      + '</div>';
  }

  // Sync wishlist active-state on dynamically rendered cards
  function syncWishlistButtons(container) {
    try {
      var raw = localStorage.getItem('wishlist:items:guest') || localStorage.getItem('wishlist:items') || '[]';
      var items = JSON.parse(raw);
      var wishedIds = new Set(items.map(function (i) { return String(i.id || ''); }));
      container.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var isActive = wishedIds.has(btn.dataset.productId || '');
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        btn.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
      });
    } catch (e) {}
  }

  // Render active-filter pills into .facets-remove so users can see & remove applied filters
  function renderActivePills() {
    var removeContainer = document.querySelector('.facets-remove');
    if (!removeContainer) return;

    var urlParams = new URLSearchParams(window.location.search);
    var pills = [];

    FILTER_DEFS.forEach(function (def) {
      var vals = urlParams.getAll(def.urlParam);
      if (!vals.length) return;
      vals.forEach(function (val) {
        var displayVal = val;
        if (def.swatch && val.indexOf('|') !== -1) displayVal = val.split('|')[0];
        if (typeof def.transform === 'function') displayVal = def.transform(displayVal) || displayVal;
        var swatchColor = (def.swatch && val.indexOf('|') !== -1) ? val.split('|')[1] : null;
        pills.push({ label: displayVal, urlParam: def.urlParam, value: val, swatchColor: swatchColor });
      });
    });

    var priceMin = urlParams.get('price_min') || urlParams.get('filter.v.price.gte') || '';
    var priceMax = urlParams.get('price_max') || urlParams.get('filter.v.price.lte') || '';
    if (priceMin || priceMax) {
      var priceLabel = priceMin && priceMax
        ? '£' + priceMin + ' – £' + priceMax
        : (priceMin ? '£' + priceMin + '+' : 'Up to £' + priceMax);
      pills.push({ label: priceLabel, urlParam: '__price__', value: '' });
    }

    if (!pills.length) {
      removeContainer.style.display = '';
      removeContainer.innerHTML = '';
      return;
    }

    var pillsHtml = pills.map(function (p) {
      var swatchHtml = p.swatchColor
        ? '<span style="display:inline-block;width:14px;height:14px;border-radius:50%;flex-shrink:0;'
          + 'background:' + esc(p.swatchColor) + ';border:1px solid rgba(0,0,0,0.15);vertical-align:middle;margin-right:4px;"></span>'
        : '';
      return '<button type="button"'
        + ' class="pills__pill pills__pill--desktop-small facets-remove__pill ts-active-pill"'
        + ' data-ts-pill-param="' + esc(p.urlParam) + '"'
        + ' data-ts-pill-value="' + esc(p.value) + '">'
        + swatchHtml
        + esc(p.label)
        + '<span class="svg-wrapper">' + SVG_PILL_CLOSE + '</span>'
        + '<span class="visually-hidden">Remove</span>'
        + '</button>';
    }).join('');

    pillsHtml += '<button type="button"'
      + ' class="button-unstyled facets__clear-all-link facets__clear-all active ts-clear-all-pill">'
      + 'Clear all</button>';

    removeContainer.innerHTML = pillsHtml;
    removeContainer.style.display = 'flex';
    removeContainer.style.flexWrap = 'wrap';
    removeContainer.style.alignItems = 'center';
    removeContainer.style.gap = 'var(--gap-xs, 8px)';
    removeContainer.style.marginBlockStart = 'var(--margin-2xs, 4px)';
    removeContainer.style.marginBlockEnd = 'var(--margin-md, 16px)';

    removeContainer.querySelectorAll('.ts-active-pill').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var param = btn.dataset.tsPillParam;
        var value = btn.dataset.tsPillValue;
        var curParams = new URLSearchParams(window.location.search);
        if (param === '__price__') {
          curParams.delete('price_min'); curParams.delete('price_max');
          curParams.delete('filter.v.price.gte'); curParams.delete('filter.v.price.lte');
        } else {
          var remaining = curParams.getAll(param).filter(function (v) { return v !== value; });
          curParams.delete(param);
          remaining.forEach(function (v) { curParams.append(param, v); });
        }
        var qs = curParams.toString();
        history.pushState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
        doReinit();
      });
    });

    var clearAllBtn = removeContainer.querySelector('.ts-clear-all-pill');
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', function () {
        var curParams = new URLSearchParams(window.location.search);
        FILTER_DEFS.forEach(function (def) { curParams.delete(def.urlParam); });
        curParams.delete('price_min'); curParams.delete('price_max');
        curParams.delete('filter.v.price.gte'); curParams.delete('filter.v.price.lte');
        var qs = curParams.toString();
        history.pushState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
        doReinit();
      });
    }
  }

  // ── Filter configuration ─────────────────────────────────────────────────
  // field     = Typesense schema field name (also the key in fp built by buildFilterParams)
  // urlParam  = URL query param used to store active selections
  // sort:     'alpha' | 'custom' | 'size'
  // If ≤1 option the filter is hidden. If hasSearch=true a search box appears.
  //
  // Field names below reflect the most common Shopify→Typesense mapping:
  //   metafield custom.gender  → mf_custom_gender
  //   variant option "Size"   → opt_size
  //   metafield custom.color  → mf_custom_color  (adjust if stored differently)
  //   metafield custom.season → mf_custom_season
  //   metafield custom.sub_type → mf_custom_sub_type
  //   discount_range          → computed field added to schema (see lib.js)

  var FILTER_DEFS = [
    {
      field: 'mf_custom_gender',
      urlParam: 'mf_custom_gender',
      label: 'Gender',
      sort: 'custom',
      order: ['Men', 'Women', 'Unisex', 'Boys', 'Girls', 'Baby Boys', 'Baby Girls', 'Unisex Kids'],
      hasSearch: false,
    },
    {
      field: 'vendor',
      urlParam: 'filter.p.vendor',
      label: 'Designers',
      sort: 'alpha',
      hasSearch: true,
    },
    {
      field: 'mf_custom_product_category',
      urlParam: 'mf_custom_product_category',
      label: 'Type',
      sort: 'custom',
      order: ['Accessories', 'Clothing', 'Footwear', 'Handbags', 'Intimates'],
      transform: function (v) {
        var MAP = {
          'darveys accessories': 'Accessories',
          'darveys clothings':   'Clothing',
          'darveys footwear':    'Footwear',
          'darveys bags':        'Handbags',
          'darveys intimates':   'Intimates',
          'darveys innerwear':   'Intimates',
        };
        return MAP[v.toLowerCase()] || v.replace(/^Darveys\s*/i, '');
      },
      hasSearch: false,
    },
    {
      field: 'mf_custom_sub_type',
      urlParam: 'mf_custom_sub_type',
      label: 'Sub Type',
      sort: 'alpha',
      hasSearch: false,
    },
    {
      field: 'opt_size',
      urlParam: 'opt_size',
      label: 'Size',
      sort: 'size',
      hasSearch: true,
    },
    {
      field: 'discount_range',
      urlParam: 'discount_range',
      label: 'Discount',
      sort: 'custom',
      order: ['0-25', '25-40', '40-50', '50+'],
      displayLabels: { '0-25': '0 - 25%', '25-40': '25% - 40%', '40-50': '40% - 50%', '50+': '50% & Above' },
      hasSearch: false,
    },
    {
      field: 'mf_custom_season',
      urlParam: 'mf_custom_season',
      label: 'Season',
      sort: 'custom',
      order: ['Summer', 'Summer/Winter', 'Winter'],
      hasSearch: false,
    },
    {
      field: 'mf_custom_color_pattern',
      urlParam: 'mf_custom_color_pattern',
      label: 'Color',
      sort: 'alpha',
      hasSearch: true,
      swatch: true,
      // Values stored as "Label|#hexcode" — strip hex for display label
      transform: function (v) { return v.indexOf('|') !== -1 ? v.split('|')[0] : v; },
    },
    // Price is rendered separately as a range input (see renderPriceFilter)
  ];

  // Size sort: named sizes smallest→largest, then numeric ascending
  var SIZE_WEIGHT = (function () {
    var order = [
      'onesize', 'one size', 'one-size', 'os',
      '3xs', 'xxxs', '2xs', 'xxs', 'xs', 's', 'm', 'l', 'xl',
      '2xl', 'xxl', '3xl', 'xxxl', '4xl', '5xl', '6xl', '7xl', '8xl',
    ];
    var map = {};
    order.forEach(function (s, i) { map[s] = i; });
    return map;
  }());

  function getSizeWeight(val) {
    var norm = String(val).toLowerCase().replace(/\s+/g, '');
    if (SIZE_WEIGHT[norm] !== undefined) return SIZE_WEIGHT[norm];
    var num = parseFloat(norm);
    if (!isNaN(num)) return 100 + num;
    return 9999;
  }

  // ── Filter skeleton placeholders ─────────────────────────────────────────
  // Injected immediately on mount so accordion headers appear while fetch is in
  // flight. Real render functions patch content in-place; the accordion elements
  // themselves are never removed so open/close state is preserved.

  function renderFilterSkeletons() {
    document.querySelectorAll('.facets__filters-wrapper').forEach(function (wrapper) {
      var prev = null;

      FILTER_DEFS.forEach(function (d) {
        var existing = wrapper.querySelector('[data-ts-filter="' + d.field + '"]');
        if (existing) { prev = existing; return; }
        var html = '<accordion-custom class="facets__item"'
          + ' data-ts-filter="' + d.field + '">'
          + '<details class="facets__panel">'
          + '<summary class="facets__summary">'
          + '<span class="facets__label">' + d.label + '</span>'
          + '<div class="facets__status-wrapper">'
          + '<facet-status-component class="facets__status" facet-type="list" data-filter-style="vertical">'
          + '</facet-status-component>'
          + '<span class="svg-wrapper icon-caret icon-animated">' + SVG_CARET + '</span>'
          + '</div>'
          + '</summary>'
          + '<floating-panel-component class="facets__inputs facets__panel-content details-content">'
          + '<facet-inputs-component>'
          + '<div class="facets__inputs-wrapper" ref="showMoreContent" style="max-height:240px;overflow-y:auto;">'
          + '<ul class="facets__inputs-list list-unstyled"></ul>'
          + '</div>'
          + '</facet-inputs-component>'
          + '</floating-panel-component>'
          + '</details>'
          + '</accordion-custom>';
        if (prev) { prev.insertAdjacentHTML('afterend', html); }
        else       { wrapper.insertAdjacentHTML('afterbegin', html); }
        prev = wrapper.querySelector('[data-ts-filter="' + d.field + '"]');
      });

      // Price skeleton (range inputs, not a facet list)
      if (!wrapper.querySelector('[data-ts-filter="price"]')) {
        var priceHtml = '<accordion-custom class="facets__item"'
          + ' data-ts-filter="price">'
          + '<details class="facets__panel">'
          + '<summary class="facets__summary">'
          + '<span class="facets__label">Price</span>'
          + '<div class="facets__status-wrapper">'
          + '<facet-status-component class="facets__status" facet-type="list" data-filter-style="vertical">'
          + '</facet-status-component>'
          + '<span class="svg-wrapper icon-caret icon-animated">' + SVG_CARET + '</span>'
          + '</div>'
          + '</summary>'
          + '<floating-panel-component class="facets__inputs facets__panel-content details-content">'
          + '<facet-inputs-component></facet-inputs-component>'
          + '</floating-panel-component>'
          + '</details>'
          + '</accordion-custom>';
        if (prev) { prev.insertAdjacentHTML('afterend', priceHtml); }
        else       { wrapper.insertAdjacentHTML('afterbegin', priceHtml); }
      }
    });
  }

  // ── Unified list filter renderer ─────────────────────────────────────────
  // Builds sorted item HTML from disjunctive facet data, then patches each
  // matching accordion's <ul> and status component in-place.
  // Returns null when the filter has ≤1 option (caller hides the element).

  function renderListFilter(def, allFacets) {
    var facetData = null;
    var i;
    for (i = 0; i < (allFacets || []).length; i++) {
      if (allFacets[i].field === def.field) { facetData = allFacets[i]; break; }
    }

    var activeParams = new URLSearchParams(window.location.search);
    var activeVals   = activeParams.getAll(def.urlParam);
    var activeSet    = {};
    activeVals.forEach(function (v) { activeSet[v] = true; });

    var grouped = {};

    (facetData ? facetData.values || [] : []).forEach(function (v) {
      var label = def.transform
        ? def.transform(v.value)
        : def.displayLabels
          ? (def.displayLabels[v.value] || v.value)
          : v.value;

      var key = label.trim().toLowerCase();

      if (!grouped[key]) {
        grouped[key] = {
          value: v.value,
          label: label,
          count: 0
        };
      }

      grouped[key].count += v.count;
    });

    var values = Object.values(grouped);

    // Sort
    if (def.sort === 'custom' && def.order) {
      var orderMap = {};
      def.order.forEach(function (s, idx) { orderMap[s.toLowerCase()] = idx; });
      values.sort(function (a, b) {
        // Try label first (catches transformed names), fall back to raw value
        var ai = orderMap[a.label.toLowerCase()];
        if (ai === undefined) ai = orderMap[a.value.toLowerCase()];
        if (ai === undefined) ai = 9999;
        var bi = orderMap[b.label.toLowerCase()];
        if (bi === undefined) bi = orderMap[b.value.toLowerCase()];
        if (bi === undefined) bi = 9999;
        return ai !== bi ? ai - bi : a.label.localeCompare(b.label);
      });
    } else if (def.sort === 'size') {
      values.sort(function (a, b) { return getSizeWeight(a.value) - getSizeWeight(b.value); });
    } else {
      values.sort(function (a, b) { return a.label.localeCompare(b.label); });
    }

    // Drop zero-count options unless currently active
    values = values.filter(function (v) { return v.count > 0 || activeSet[v.value]; });

    // Hide entire filter when only 1 (or 0) option exists
    if (values.length <= 1) return null;

    var items = values.map(function (v, idx) {
      var inputId    = 'ts-' + def.field.replace(/[^a-z0-9]/g, '-') + '-' + idx;
      var isActive   = !!activeSet[v.value];
      var isDisabled = v.count === 0 && !isActive;
      var labelInner = '';
      if (def.swatch && v.value.indexOf('|') !== -1) {
        var swatchColor = v.value.split('|')[1];
        // padding-inline-start creates the gap after the checkbox icon (same as .checkbox__label-text does natively).
        // The inner span has NO extra padding so swatch and name sit flush with just a small gap between them.
        labelInner = '<span style="display:inline-flex;align-items:center;padding-inline-start:var(--checkbox-label-padding);gap:6px;">'
          + '<span class="filter-color-swatch" aria-hidden="true"'
          + ' data-label="' + esc(v.label) + '"'
          + ' style="width:16px;height:16px;border-radius:50%;flex-shrink:0;'
          + 'background:' + esc(swatchColor) + ';border:1px solid rgba(0,0,0,0.15);"></span>'
          + '<span style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + esc(v.label) + '</span>'
          + '</span>';
      } else {
        labelInner = '<span class="checkbox__label-text">' + esc(v.label) + '</span>';
      }
      return '<li class="facets__inputs-list-item' + (isDisabled ? ' facets__inputs-list-item--disabled' : '') + '"'
        + ' data-value-label="' + esc(v.label) + '">'
        + '<div class="checkbox' + (isDisabled ? ' checkbox--disabled' : '') + '">'
        + '<input type="checkbox"'
        + ' name="' + esc(def.urlParam) + '"'
        + ' value="' + esc(v.value) + '"'
        + ' id="' + inputId + '"'
        + ' class="checkbox__input"'
        + ' data-label="' + esc(v.label) + '"'
        + (isActive   ? ' checked'  : '')
        + (isDisabled ? ' disabled' : '')
        + '>'
        + '<label class="checkbox__label" for="' + inputId + '" role="checkbox">'
        + SVG_CHECKMARK
        + labelInner
        + '<span class="filters__option-count">(' + v.count + ')</span>'
        + '</label>'
        + '</div>'
        + '</li>';
    }).join('');

    var statusHtml = activeVals.length
      ? '<span hide-when-empty ref="facetStatus">' + activeVals.length + '</span>'
      : '';

    // Prepend a "Clear" link to the list when values are active so users can remove the filter
    if (activeVals.length) {
      var clearLi = '<li class="facets__inputs-list-item" style="padding-bottom:6px;margin-bottom:4px;border-bottom:1px solid var(--color-border,rgba(0,0,0,0.1));">'
        + '<button type="button" class="ts-clear-filter button button-unstyled"'
        + ' data-ts-clear-url-param="' + esc(def.urlParam) + '"'
        + ' style="font-size:0.75rem;text-decoration:underline;opacity:0.65;padding:0;">Clear ' + esc(def.label) + '</button>'
        + '</li>';
      items = clearLi + items;
    }

    // Safety net in case skeleton wasn't already injected
    renderFilterSkeletons();

    document.querySelectorAll('.facets__filters-wrapper').forEach(function (wrapper) {
      var filterEl = wrapper.querySelector('[data-ts-filter="' + def.field + '"]');
      if (!filterEl) return;

      filterEl.style.display = '';

      // Add search input once on first real render (skeleton omits it)
      if (def.hasSearch && !filterEl.querySelector('.facets__search')) {
        var fic = filterEl.querySelector('facet-inputs-component');
        if (fic) {
          fic.insertAdjacentHTML('afterbegin',
            '<div class="facets__search">'
            + '<span class="facets__search-icon" aria-hidden="true">'
            + '<svg viewBox="0 0 20 20" focusable="false" aria-hidden="true">'
            + '<circle cx="9" cy="9" r="6" fill="none" stroke="currentColor" stroke-width="1.5"></circle>'
            + '<line x1="13.5" y1="13.5" x2="18" y2="18" stroke="currentColor" stroke-width="1.5"></line>'
            + '</svg></span>'
            + '<input class="facets__search-input" type="search" placeholder="Search"'
            + ' aria-label="Search filter options" data-facet-search>'
            + '</div>'
          );
        }
      }

      // Patch list + status in-place — accordion element never removed → stays open
      var ul = filterEl.querySelector('.facets__inputs-list');
      if (ul) {
        ul.innerHTML = items;
        // Wire up the "Clear <Filter>" button if present
        var clearBtn = ul.querySelector('.ts-clear-filter');
        if (clearBtn) {
          clearBtn.addEventListener('click', function () {
            var curParams = new URLSearchParams(window.location.search);
            curParams.delete(clearBtn.dataset.tsClearUrlParam);
            var qs = curParams.toString();
            history.pushState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
            doReinit();
          });
        }
      }
      var statusComp = filterEl.querySelector('facet-status-component');
      if (statusComp) statusComp.innerHTML = statusHtml;

      // Property assignment prevents listener stacking on search input
      if (def.hasSearch) {
        var searchInput = filterEl.querySelector('.facets__search-input');
        if (searchInput) {
          searchInput.oninput = function () {
            var q = this.value.toLowerCase();
            filterEl.querySelectorAll('.facets__inputs-list-item').forEach(function (item) {
              item.style.display = (item.dataset.valueLabel || '').toLowerCase().indexOf(q) !== -1 ? '' : 'none';
            });
          };
        }
      }

      // Checkboxes are fresh (ul.innerHTML was replaced), addEventListener is safe
      var urlP = def.urlParam;
      filterEl.querySelectorAll('input[name="' + urlP + '"]').forEach(function (input) {
        input.addEventListener('change', function () {
          // Read from URL (not DOM) so desktop+mobile duplicate checkboxes don't interfere
          var curParams = new URLSearchParams(window.location.search);
          var existing = curParams.getAll(urlP);
          curParams.delete(urlP);
          if (input.checked) {
            existing.push(input.value);
          } else {
            existing = existing.filter(function (v) { return v !== input.value; });
          }
          var seen = {};
          existing.forEach(function (v) {
            if (!seen[v]) { seen[v] = true; curParams.append(urlP, v); }
          });
          var qs = curParams.toString();
          history.pushState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
          doReinit();
        });
      });
    });

    return true;
  }

  // ── Price filter ─────────────────────────────────────────────────────────

  function renderPriceFilter() {
    var urlParams = new URLSearchParams(window.location.search);
    var minVal    = urlParams.get('price_min') || urlParams.get('filter.v.price.gte') || '';
    var maxVal    = urlParams.get('price_max') || urlParams.get('filter.v.price.lte') || '';
    var statusHtml = (minVal || maxVal)
      ? '<span hide-when-empty ref="facetStatus">1</span>'
      : '';

    document.querySelectorAll('.facets__filters-wrapper').forEach(function (wrapper) {
      var filterEl = wrapper.querySelector('[data-ts-filter="price"]');
      if (!filterEl) return;

      // Build price input UI once
      if (!filterEl.querySelector('.ts-price-filter')) {
        var fic = filterEl.querySelector('facet-inputs-component');
        if (fic) {
          fic.innerHTML = '<div class="ts-price-filter" style="padding:8px 0;">'
            + '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">'
            + '<input type="number" class="ts-price-min" placeholder="Min £" min="0" step="1"'
            + ' style="width:76px;padding:5px 8px;border:1px solid currentColor;background:transparent;color:inherit;font:inherit;">'
            + '<span>–</span>'
            + '<input type="number" class="ts-price-max" placeholder="Max £" min="0" step="1"'
            + ' style="width:76px;padding:5px 8px;border:1px solid currentColor;background:transparent;color:inherit;font:inherit;">'
            + '<button type="button" class="ts-price-apply"'
            + ' style="padding:5px 12px;cursor:pointer;background:var(--color-foreground,#000);color:var(--color-background,#fff);border:none;font:inherit;white-space:nowrap;">Go</button>'
            + '</div>'
            + '</div>';
        }
      }

      var minInput = filterEl.querySelector('.ts-price-min');
      var maxInput = filterEl.querySelector('.ts-price-max');
      if (minInput) minInput.value = minVal;
      if (maxInput) maxInput.value = maxVal;

      var applyBtn = filterEl.querySelector('.ts-price-apply');
      if (applyBtn) {
        applyBtn.onclick = function () {
          var curParams = new URLSearchParams(window.location.search);
          var minEl = filterEl.querySelector('.ts-price-min');
          var maxEl = filterEl.querySelector('.ts-price-max');
          var min = minEl ? minEl.value : '';
          var max = maxEl ? maxEl.value : '';
          curParams.delete('price_min');
          curParams.delete('price_max');
          curParams.delete('filter.v.price.gte');
          curParams.delete('filter.v.price.lte');
          if (min) curParams.set('price_min', min);
          if (max) curParams.set('price_max', max);
          var qs = curParams.toString();
          history.pushState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
          doReinit();
        };
      }

      var statusComp = filterEl.querySelector('facet-status-component');
      if (statusComp) statusComp.innerHTML = statusHtml;
    });
  }

  // ── Render all filters after data arrives ─────────────────────────────────

  function renderAllFilters(disjunctiveFacets) {
    FILTER_DEFS.forEach(function (def) {
      var result = renderListFilter(def, disjunctiveFacets[def.field] || []);
      if (result === null) {
        document.querySelectorAll('[data-ts-filter="' + def.field + '"]').forEach(function (el) {
          el.style.display = 'none';
        });
      }
    });
    renderPriceFilter();
    renderMobileFilters(disjunctiveFacets);
  }

  // ── Mobile two-panel filter UI (Typesense path) ──────────────────────────

  var SVG_CHECKMARK_MOBILE = '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-checkmark">'
    + '<path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658"'
    + ' stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function getSortLabelFromParams(urlParams) {
    var custom = urlParams.get('custom_sort') || '';
    if (custom === 'discount-desc') return 'discount-desc';
    if (custom === 'discount-asc')  return 'discount-asc';
    return urlParams.get('sort_by') || 'manual';
  }

  function buildMobileSortPanel(currentSort) {
    var OPTS = [
      { value: 'manual',        label: 'Relevance' },
      { value: 'created-desc',  label: 'New Arrivals' },
      { value: 'price-desc',    label: 'Price: High to Low' },
      { value: 'price-asc',     label: 'Price: Low to High' },
      { value: 'discount-desc', label: 'Discount: High to Low', isCustom: true },
      { value: 'discount-asc',  label: 'Discount: Low to High', isCustom: true },
    ];
    return '<ul class="mobile-filters__options list-unstyled">'
      + OPTS.map(function (opt, idx) {
        var id = 'mts-sort-' + idx;
        var checked = currentSort === opt.value;
        return '<li class="mobile-filters__option">'
          + '<input class="mobile-filters__checkbox" type="radio" name="mts-sort-by" id="' + id + '"'
          + ' value="' + esc(opt.value) + '"'
          + ' data-mts-sort-custom="' + (opt.isCustom ? '1' : '0') + '"'
          + (checked ? ' checked' : '') + '>'
          + '<label class="mobile-filters__checkbox-label" for="' + id + '">'
          + '<span class="mobile-filters__checkbox-box" aria-hidden="true">' + SVG_CHECKMARK_MOBILE + '</span>'
          + '<span class="mobile-filters__option-text">' + esc(opt.label) + '</span>'
          + '</label></li>';
      }).join('')
      + '</ul>';
  }

  function buildMobilePricePanel(urlParams) {
    var minVal = urlParams.get('price_min') || '';
    var maxVal = urlParams.get('price_max') || '';
    return '<div class="mobile-filters__price-range">'
      + '<div class="mobile-filters__price-inputs">'
      + '<label class="mobile-filters__price-field">'
      + '<span class="mobile-filters__price-label">£</span>'
      + '<input class="mobile-filters__price-input" type="number" min="0" step="1" placeholder="Min"'
      + ' value="' + esc(minVal) + '" data-mts-price-min>'
      + '</label>'
      + '<label class="mobile-filters__price-field">'
      + '<span class="mobile-filters__price-label">£</span>'
      + '<input class="mobile-filters__price-input" type="number" min="0" step="1" placeholder="Max"'
      + ' value="' + esc(maxVal) + '" data-mts-price-max>'
      + '</label>'
      + '</div></div>';
  }

  function buildMobileCheckboxPanel(def, disjunctiveFacets, urlParams) {
    var allFacets = disjunctiveFacets[def.field] || [];
    var facetData = null;
    for (var i = 0; i < allFacets.length; i++) {
      if (allFacets[i].field === def.field) { facetData = allFacets[i]; break; }
    }

    var activeVals = urlParams.getAll(def.urlParam);
    var activeSet = {};
    activeVals.forEach(function (v) { activeSet[v] = true; });

    var grouped = {};

    (facetData ? facetData.values || [] : []).forEach(function (v) {
      var label = def.transform
        ? def.transform(v.value)
        : def.displayLabels
          ? (def.displayLabels[v.value] || v.value)
          : v.value;

      var key = label.trim().toLowerCase();

      if (!grouped[key]) {
        grouped[key] = {
          value: v.value,
          label: label,
          count: 0
        };
      }

      grouped[key].count += v.count;
    });

    var values = Object.values(grouped);

    if (def.sort === 'custom' && def.order) {
      var orderMap = {};
      def.order.forEach(function (s, oi) { orderMap[s.toLowerCase()] = oi; });
      values.sort(function (a, b) {
        var ai = orderMap[a.label.toLowerCase()]; if (ai === undefined) ai = orderMap[a.value.toLowerCase()]; if (ai === undefined) ai = 9999;
        var bi = orderMap[b.label.toLowerCase()]; if (bi === undefined) bi = orderMap[b.value.toLowerCase()]; if (bi === undefined) bi = 9999;
        return ai !== bi ? ai - bi : a.label.localeCompare(b.label);
      });
    } else if (def.sort === 'size') {
      values.sort(function (a, b) { return getSizeWeight(a.value) - getSizeWeight(b.value); });
    } else {
      values.sort(function (a, b) { return a.label.localeCompare(b.label); });
    }

    values = values.filter(function (v) { return v.count > 0 || activeSet[v.value]; });

    if (!values.length) return '<p style="padding:1rem;font-size:0.875rem;opacity:0.5;text-align:center;">No options</p>';

    var isSwatch = !!def.swatch;
    var needsSearch = !isSwatch;

    var searchHtml = needsSearch
      ? '<div class="mobile-filters__search">'
        + '<span class="mobile-filters__search-icon" aria-hidden="true">'
        + '<svg viewBox="0 0 20 20" focusable="false" aria-hidden="true"><circle cx="9" cy="9" r="6" fill="none" stroke="currentColor" stroke-width="1.5"></circle><line x1="13.5" y1="13.5" x2="18" y2="18" stroke="currentColor" stroke-width="1.5"></line></svg></span>'
        + '<input class="mobile-filters__search-input" type="search" placeholder="Search" data-mts-search>'
        + '</div>'
      : '';

    var itemsHtml = values.map(function (v, idx) {
      var inputId  = 'mts-' + def.field.replace(/[^a-z0-9]/g, '-') + '-' + idx;
      var isActive = !!activeSet[v.value];
      var isDisabled = v.count === 0 && !isActive;

      var inner = '';
      if (isSwatch && v.value.indexOf('|') !== -1) {
        var hex = v.value.split('|')[1];
        inner = '<span class="mobile-filters__checkbox-box" aria-hidden="true">' + SVG_CHECKMARK_MOBILE + '</span>'
          + '<span style="display:inline-flex;align-items:center;gap:6px;">'
          + '<span style="width:20px;height:20px;border-radius:50%;flex-shrink:0;background:' + esc(hex) + ';border:1px solid rgba(0,0,0,0.15);"></span>'
          + '<span class="mobile-filters__option-text">' + esc(v.label) + '</span></span>';
      } else {
        inner = '<span class="mobile-filters__checkbox-box" aria-hidden="true">' + SVG_CHECKMARK_MOBILE + '</span>'
          + '<span class="mobile-filters__option-text">' + esc(v.label) + '</span>';
      }

      return '<li class="mobile-filters__option' + (isDisabled ? ' is-disabled' : '') + '" data-value-label="' + esc(v.label) + '">'
        + '<input class="mobile-filters__checkbox" type="checkbox"'
        + ' id="' + inputId + '"'
        + ' data-mts-param="' + esc(def.urlParam) + '"'
        + ' data-mts-field="' + esc(def.field) + '"'
        + ' value="' + esc(v.value) + '"'
        + (isActive   ? ' checked'  : '')
        + (isDisabled ? ' disabled' : '') + '>'
        + '<label class="mobile-filters__checkbox-label" for="' + inputId + '">'
        + inner
        + '<span class="mobile-filters__option-count">(' + v.count + ')</span>'
        + '</label></li>';
    }).join('');

    return searchHtml + '<ul class="mobile-filters__options list-unstyled">' + itemsHtml + '</ul>';
  }

  function applyMobileFilters() {
    var panelsEl = document.querySelector('[data-mobile-ts-facet-panels]');
    if (!panelsEl) return;

    var urlParams = new URLSearchParams(window.location.search);

    // Clear existing filter + sort params
    FILTER_DEFS.forEach(function (def) { urlParams.delete(def.urlParam); });
    urlParams.delete('price_min');
    urlParams.delete('price_max');
    urlParams.delete('sort_by');
    urlParams.delete('custom_sort');
    urlParams.delete('page');

    // Collect checked filter checkboxes
    panelsEl.querySelectorAll('input[data-mts-param]:checked').forEach(function (input) {
      urlParams.append(input.dataset.mtsParam, input.value);
    });

    // Price inputs
    var priceMin = panelsEl.querySelector('[data-mts-price-min]');
    var priceMax = panelsEl.querySelector('[data-mts-price-max]');
    if (priceMin && priceMin.value) urlParams.set('price_min', priceMin.value);
    if (priceMax && priceMax.value) urlParams.set('price_max', priceMax.value);

    // Sort radio
    var sortInput = panelsEl.querySelector('input[name="mts-sort-by"]:checked');
    if (sortInput && sortInput.value !== 'manual') {
      if (sortInput.dataset.mtsSortCustom === '1') {
        urlParams.set('custom_sort', sortInput.value);
      } else {
        urlParams.set('sort_by', sortInput.value);
      }
    }

    var qs = urlParams.toString();
    history.pushState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
    doReinit();
  }

  function renderMobileFilters(disjunctiveFacets) {
    var listEl   = document.querySelector('[data-mobile-ts-facet-list]');
    var panelsEl = document.querySelector('[data-mobile-ts-facet-panels]');
    if (!listEl || !panelsEl) return;
    // Clear loader that was set when a tab switch triggered applyMobileFilters
    panelsEl.removeAttribute('data-mts-loading');

    var urlParams   = new URLSearchParams(window.location.search);
    var currentSort = getSortLabelFromParams(urlParams);

    // Remember which tab was active before rebuild
    var activeTab = (listEl.querySelector('[data-mobile-ts-tab].is-active') || {}).dataset;
    var activeField = activeTab ? activeTab.mobileTsTab : (FILTER_DEFS[0] ? FILTER_DEFS[0].field : '__price__');

    // Extended filter list: standard filters + Price + Sort
    var MOBILE_PANELS = FILTER_DEFS.map(function (def) {
      return { field: def.field, label: def.label, type: 'list', def: def };
    }).concat([
      { field: '__price__', label: 'Price',  type: 'price' },
      { field: '__sort__',  label: 'Sort',   type: 'sort'  },
    ]);

    var listHtml   = '';
    var panelsHtml = '';

    MOBILE_PANELS.forEach(function (p) {
      var activeCount = 0;
      if (p.type === 'list') {
        activeCount = urlParams.getAll(p.def.urlParam).length;
      } else if (p.type === 'price') {
        if (urlParams.has('price_min') || urlParams.has('price_max')) activeCount = 1;
      } else if (p.type === 'sort') {
        activeCount = (currentSort && currentSort !== 'manual') ? 1 : 0;
      }

      var isActive = p.field === activeField;

      var countHtml = activeCount > 0
        ? '<span class="mobile-filters__facet-count" data-mts-count="' + p.field + '">' + activeCount + '</span>'
        : '<span class="mobile-filters__facet-count hidden" data-mts-count="' + p.field + '" aria-hidden="true">' + activeCount + '</span>';

      listHtml += '<li class="mobile-filters__facet-item">'
        + '<button type="button" class="mobile-filters__facet-button' + (isActive ? ' is-active' : '') + '"'
        + ' data-mobile-ts-tab="' + p.field + '">'
        + '<span class="mobile-filters__facet-label">' + esc(p.label) + '</span>'
        + countHtml
        + '</button></li>';

      var panelContent = '';
      if      (p.type === 'list')  panelContent = buildMobileCheckboxPanel(p.def, disjunctiveFacets, urlParams);
      else if (p.type === 'price') panelContent = buildMobilePricePanel(urlParams);
      else if (p.type === 'sort')  panelContent = buildMobileSortPanel(currentSort);

      panelsHtml += '<div class="mobile-filters__facet-panel' + (isActive ? ' is-active' : '') + '"'
        + ' data-mobile-ts-panel="' + p.field + '"'
        + (isActive ? '' : ' hidden') + '>'
        + panelContent
        + '</div>';
    });

    listEl.innerHTML   = listHtml;
    panelsEl.innerHTML = panelsHtml;

    // Initial render is always correct — clear the flag so first tab switch won't re-fetch
    mobilePendingChanged = false;

    // Enable/disable Clear All button based on whether any TS filters are active in URL
    var clearBtnEl = document.querySelector('[data-mobile-filters-clear]');
    if (clearBtnEl) {
      var curUrlPs = new URLSearchParams(window.location.search);
      var hasActiveFilters = FILTER_DEFS.some(function (def) { return curUrlPs.has(def.urlParam); })
        || curUrlPs.has('price_min') || curUrlPs.has('price_max');
      clearBtnEl.disabled = !hasActiveFilters;
    }

    // Wire tab buttons
    listEl.querySelectorAll('[data-mobile-ts-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var field = btn.dataset.mobileTsTab;
        listEl.querySelectorAll('[data-mobile-ts-tab]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        panelsEl.querySelectorAll('[data-mobile-ts-panel]').forEach(function (panel) {
          var active = panel.dataset.mobileTsPanel === field;
          panel.classList.toggle('is-active', active);
          panel.toggleAttribute('hidden', !active);
        });
        // If a checkbox changed, apply filters exactly like the web Apply button does:
        // updates URL, fetches products, updates Show count, re-renders all filter panels
        if (mobilePendingChanged) {
          mobilePendingChanged = false;
          panelsEl.setAttribute('data-mts-loading', '');
          applyMobileFilters();
        }
      });
    });

    // Wire search inputs inside panels
    panelsEl.querySelectorAll('[data-mts-search]').forEach(function (input) {
      var panel = input.closest('[data-mobile-ts-panel]');
      if (!panel) return;
      input.oninput = function () {
        var q = this.value.toLowerCase();
        panel.querySelectorAll('.mobile-filters__option').forEach(function (item) {
          item.style.display = (item.dataset.valueLabel || '').toLowerCase().indexOf(q) !== -1 ? '' : 'none';
        });
      };
    });

    // Checkbox change: update left badge only — mark pending so next tab switch recalculates
    panelsEl.querySelectorAll('input[data-mts-field]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var field = cb.dataset.mtsField;
        var param = cb.dataset.mtsParam;
        var count = panelsEl.querySelectorAll('input[data-mts-param="' + param + '"]:checked').length;
        var badge = listEl.querySelector('[data-mts-count="' + field + '"]');
        if (badge) {
          badge.textContent = String(count);
          badge.classList.toggle('hidden', count === 0);
          badge.toggleAttribute('aria-hidden', count === 0);
        }
        mobilePendingChanged = true;
      });
    });
  }

  function mountMobileApply() {
    var applyBtn = document.querySelector('[data-mobile-filters-apply]');
    if (!applyBtn || applyBtn._tsMobileWired) return;
    applyBtn._tsMobileWired = true;
    applyBtn.addEventListener('click', function () {
      // mobile-filters.js closes the dialog; we apply filters after close animation
      setTimeout(function () { applyMobileFilters(); }, 350);
    });
  }

  function mountMobileClear() {
    var clearBtn = document.querySelector('[data-mobile-filters-clear]');
    if (!clearBtn || clearBtn._tsMobileClearWired) return;
    clearBtn._tsMobileClearWired = true;
    clearBtn.addEventListener('click', function () {
      var panelsEl = document.querySelector('[data-mobile-ts-facet-panels]');
      if (panelsEl) panelsEl.setAttribute('data-mts-loading', '');
      mobilePendingChanged = false;
      var urlParams = new URLSearchParams(window.location.search);
      FILTER_DEFS.forEach(function (def) { urlParams.delete(def.urlParam); });
      urlParams.delete('price_min');
      urlParams.delete('price_max');
      urlParams.delete('sort_by');
      urlParams.delete('custom_sort');
      urlParams.delete('page');
      var qs = urlParams.toString();
      history.pushState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
      doReinit();
    });
  }

  var mobilePendingChanged = false; // true when a checkbox changed since last render

  // ── Our loader + sentinel ────────────────────────────────────────────────

  var tsLoader   = null;
  var tsSentinel = null;
  var ioObserver = null;

  function mountOurElements() {
    if (ioObserver)  { ioObserver.disconnect(); ioObserver = null; }
    if (tsLoader   && tsLoader.parentNode)   tsLoader.parentNode.removeChild(tsLoader);
    if (tsSentinel && tsSentinel.parentNode) tsSentinel.parentNode.removeChild(tsSentinel);

    tsLoader = document.createElement('div');
    tsLoader.className = 'collection-infinite-loader';
    tsLoader.hidden = true;
    tsLoader.setAttribute('aria-hidden', 'true');
    tsLoader.innerHTML =
      '<div class="collection-infinite-loader__track" role="img" aria-label="Loading">'
      + '<span class="collection-infinite-loader__bar"></span></div>';

    tsSentinel = document.createElement('span');

    gridEl.insertAdjacentElement('afterend', tsSentinel);
    gridEl.insertAdjacentElement('afterend', tsLoader);

    if (typeof IntersectionObserver !== 'undefined') {
      ioObserver = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting || loading) return;
        var totalPages = Math.ceil(totalFound / PER_PAGE);
        if (currentPage > 0 && currentPage < totalPages) fetchPage(currentPage + 1);
      }, { rootMargin: '0px 0px 800px 0px' });
      ioObserver.observe(tsSentinel);
    }

    renderFilterSkeletons();
  }

  // Hide Shopify's server-rendered count immediately so stale numbers (e.g. 250001)
  // never flash before Typesense updates them.
  function hideShopifyCounts() {
    document.querySelectorAll('.filter-header__count, .collection-product-count').forEach(function (el) {
      el.style.visibility = 'hidden';
    });
  }

  hideShopifyCounts();
  mountOurElements();
  mountMobileApply();
  mountMobileClear();

  // ── Discount sort URL detection ──────────────────────────────────────────

  var lastCustomSort = new URLSearchParams(window.location.search).get('custom_sort') || '';

  var _origPushState = history.pushState.bind(history);
  history.pushState = function (state, title, url) {
    _origPushState(state, title, url);
    var newCustomSort = new URLSearchParams(window.location.search).get('custom_sort') || '';
    if (newCustomSort !== lastCustomSort && (newCustomSort === 'discount-desc' || newCustomSort === 'discount-asc')) {
      doReinit();
    }
    lastCustomSort = newCustomSort;
  };

  window.addEventListener('popstate', function () {
    var newCustomSort = new URLSearchParams(window.location.search).get('custom_sort') || '';
    lastCustomSort = newCustomSort;
    doReinit();
  });

  function showLoader() { if (tsLoader) { tsLoader.hidden = false; tsLoader.removeAttribute('aria-hidden'); } }
  function hideLoader() { if (tsLoader) { tsLoader.hidden = true;  tsLoader.setAttribute('aria-hidden', 'true'); } }

  // ── fetch + render ───────────────────────────────────────────────────────

  function buildFilterParams(params) {
    var fp = {};
    params.forEach(function (v, k) {
      // Price params (native Shopify or our own)
      if (k === 'filter.v.price.gte' || k === 'price_min') { fp['price_min'] = v; return; }
      if (k === 'filter.v.price.lte' || k === 'price_max') { fp['price_max'] = v; return; }
      // Native Shopify vendor / product_type
      if (k === 'filter.p.vendor')       { fp['vendor']       = fp['vendor']       ? fp['vendor']       + ',' + v : v; return; }
      if (k === 'filter.p.product_type') { fp['product_type'] = fp['product_type'] ? fp['product_type'] + ',' + v : v; return; }
      // Native Shopify variant option params
      if (k.indexOf('filter.v.option.') === 0) {
        var tsKey = 'opt_' + k.slice(16).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/, '');
        fp[tsKey] = fp[tsKey] ? fp[tsKey] + ',' + v : v;
        return;
      }
      // Pass-through: mf_*, opt_*, discount_range are already Typesense field names
      if (k.indexOf('mf_') === 0 || k.indexOf('opt_') === 0 || k === 'discount_range') {
        fp[k] = fp[k] ? fp[k] + ',' + v : v;
      }
    });
    return fp;
  }

  function fetchPage(page) {
    if (loading) return;
    loading = true;
    showLoader();

    var gen    = fetchGen;
    var tsSort = getTsSort();
    var params = new URLSearchParams(window.location.search);
    var fp     = buildFilterParams(params);

    // Dim grid immediately to signal reloading
    if (page === 1) gridEl.style.opacity = '0.4';

    function buildQs(perPage, pageNum, excludeKey) {
      var qs = new URLSearchParams();
      // 'all' is Shopify's virtual collection — every product belongs to it implicitly,
      // but no product has 'all' in its stored collections[], so we skip this filter.
      if (collectionHandle && collectionHandle !== 'all') {
        qs.set('collections', collectionHandle);
      }
      qs.set('q',        params.get('q') || '*');
      qs.set('per_page', String(perPage));
      qs.set('page',     String(pageNum));
      if (tsSort) qs.set('sort', tsSort);
      Object.keys(fp).forEach(function (k) {
        if (k !== excludeKey) qs.set(k, fp[k]);
      });
      return qs;
    }

    // Main request — products + facets for count/pills
    var mainReq = fetch(apiUrl + '/search?' + buildQs(PER_PAGE, page).toString())
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });

    // Disjunctive facet requests (page 1 only): each omits its own group so all
    // options stay visible while another filter is active. Fire in parallel with
    // the main request so they don't add any serial latency.
    var disjReqs = [];
    if (page === 1) {
      FILTER_DEFS.forEach(function (def) {
        disjReqs.push(
          fetch(apiUrl + '/search?' + buildQs(1, 1, def.field).toString())
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; })
        );
      });
    }

    // Phase 1 — render products as soon as the main request returns (don't wait for filters)
    mainReq
      .then(function (data) {
        if (gen !== fetchGen) return;

        totalFound = data.found || 0;

        if (page === 1) {
          var inlineScript = gridEl.querySelector('script');
          gridEl.innerHTML = '';
          if (inlineScript) gridEl.appendChild(inlineScript);
        }

        var existing = gridEl.querySelectorAll('li[data-product-id]').length;
        var html = (data.hits || []).map(function (hit, i) {
          return buildCard(hit, existing + i);
        }).join('');
        gridEl.insertAdjacentHTML('beforeend', html);
        syncWishlistButtons(gridEl);

        if (page === 1) {
          var countStr = totalFound.toLocaleString();
          document.querySelectorAll('.collection-product-count').forEach(function (el) {
            el.textContent = '(' + countStr + ')';
            el.style.visibility = 'visible';
          });
          document.querySelectorAll('.filter-header__count').forEach(function (el) {
            el.textContent = countStr + ' Results';
            el.style.visibility = 'visible';
          });
          renderActivePills();
        }

        gridEl.dataset.lastPage = '1';
        currentPage = page;
        loading = false;
        hideLoader();
        gridEl.style.opacity = '';

        // Phase 2 — update filter panels when disjunctive requests finish (non-blocking)
        if (page === 1 && disjReqs.length) {
          Promise.all(disjReqs).then(function (disjResults) {
            if (gen !== fetchGen) return;
            var disjunctiveFacets = {};
            FILTER_DEFS.forEach(function (def, i) {
              var r = disjResults[i];
              disjunctiveFacets[def.field] = r ? r.facets : (data.facets || []);
            });
            renderAllFilters(disjunctiveFacets);
          });
        }
      })
      .catch(function (err) {
        console.error('[Typesense] fetch failed — check apiUrl in collection.json:', err);
        if (gen === fetchGen) { loading = false; hideLoader(); gridEl.style.opacity = ''; }
      });
  }

  // ── React to section re-renders triggered by sort/filter changes ─────────

  var pendingReinit = false;

  document.addEventListener('filter:update', function () {
    pendingReinit = true;
  });

  new MutationObserver(function (mutations) {
    var attrMutation = mutations.some(function (m) {
      return m.type === 'attributes' && m.attributeName === 'data-last-page';
    });
    if (attrMutation && gridEl.dataset.lastPage !== '1') {
      pendingReinit = false;
      gridEl.dataset.lastPage = '1';
      doReinit();
      return;
    }

    if (pendingReinit && mutations.some(function (m) { return m.type === 'childList'; })) {
      if (!gridEl.querySelector('li[data-product-id]')) {
        pendingReinit = false;
        doReinit();
      }
    }
  }).observe(gridEl, {
    attributes:      true,
    attributeFilter: ['data-last-page'],
    childList:       true,
  });

  function doReinit() {
    fetchGen++;
    loading  = false;
    hideLoader();
    currentPage = 0;
    totalFound  = 0;
    hideShopifyCounts();
    mountOurElements();
    fetchPage(1);
  }

  fetchPage(1);
})();
